// @flow

import React from 'react';
import type { Node } from 'react';
import { useIntl } from 'react-intl';
import { Button, MediaQuery } from '@riseart/common';
import { MoreImagesIcon } from '@riseart/icons';
import { EnquireArtworkFormModel } from 'shared_models/forms/EnquireArtwork';
import { EnquireOverlay } from 'shared_components/enquire/Overlay';
import { EnquireArtworkForm } from 'shared_components/forms/enquire/Artwork';

import { raScreenLg } from '@riseart/antd-provider/dist/website/variables.less';

type Props = {
  artwork: Object,
  selectedFrame: Object,
  trigger: string,
};

/**
 * EnquireImagesForm
 *
 * @param {props} Props
 */
export const EnquireImagesForm = ({ artwork, selectedFrame, trigger }: Props): Node => {
  const { formatMessage } = useIntl();

  const requireMoreImagesTitle = formatMessage({ id: 'components.art.requestMoreImages.title' });

  return (
    <EnquireOverlay
      title={requireMoreImagesTitle}
      component={({ onClose }) => (
        <EnquireArtworkForm
          onClose={onClose}
          artwork={artwork}
          selectedFrame={selectedFrame}
          trigger={trigger}
          formSettings={{
            settings: EnquireArtworkFormModel.settings,
            fields: EnquireArtworkFormModel.fields.map((field) => {
              if (field.name === 'subject') {
                return {
                  ...field,
                  options: (intl) =>
                    ['additionalImages', 'pricing', 'shipping', 'sellArtwork', 'other'].map(
                      (key) => {
                        const text = intl.formatMessage({
                          id: `forms.emailEnquire.subject.${key}`,
                        });

                        // the value and the text in the option are the same in this field
                        return { value: key, text };
                      },
                    ),
                };
              }
              return field;
            }),
          }}
          additionalInitialValues={{
            message: formatMessage({ id: 'components.art.requestMoreImages.message' }),
          }}
        />
      )}
    >
      <Button size="medium" type="link" linkType="light" icon={<MoreImagesIcon />}>
        <span>
          <MediaQuery minWidth={raScreenLg}>
            {(isTablet) =>
              isTablet
                ? requireMoreImagesTitle
                : formatMessage({ id: 'components.art.requestMoreImages.titleTruncated' })
            }
          </MediaQuery>
        </span>
      </Button>
    </EnquireOverlay>
  );
};
